import { render, staticRenderFns } from "./FormRadio.vue?vue&type=template&id=1bab6b92&scoped=true"
import script from "./FormRadio.vue?vue&type=script&lang=ts"
export * from "./FormRadio.vue?vue&type=script&lang=ts"
import style0 from "./FormRadio.vue?vue&type=style&index=0&id=1bab6b92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab6b92",
  null
  
)

export default component.exports